export const typeLabel = 'TYPE';
export const addRegionPlaceholder = 'add a region...';
